import {
    Background,
    BackgroundColor,
    Container,
    Spacer,
    SpacerVariant,
    backgroundOptions,
    spacerOptions,
} from "../../components/layout"
import { Repeater, types } from "react-bricks/frontend"

import { CenterTextProps } from "../../text/CenterText"
import GridSlider from "../../components/slider/grid-slider"
import { ImageTextSliderItemProps } from "./ImageText"
import React from "react"
import { TypographyColor } from "../../components/typography"

interface ImageTextSliderProps {
    background: { color: BackgroundColor } | BackgroundColor
    repeater?: {
        id: string
        props: ImageTextSliderItemProps
        type: "ImageTextSliderItem"
    }[]
    spacerTop: boolean
    spacerBottom: boolean
    variantTop?: SpacerVariant
    variantBottom?: SpacerVariant
}

const ImageTextSlider: types.Brick<ImageTextSliderProps> = ({
    background,
    repeater,
    spacerTop,
    spacerBottom,
    variantTop,
    variantBottom,
}) => {
    const bgColor = typeof background === "object" ? background.color : background

    return (
        <Background color={bgColor}>
            <Spacer variant={!spacerTop ? SpacerVariant.None : variantTop} />
            <Repeater
                propName="centerText"
                renderWrapper={children => <Container>{children}</Container>}
                itemProps={
                    {
                        color:
                            bgColor === BackgroundColor.Green || bgColor === BackgroundColor.DarkBlumine
                                ? TypographyColor.White
                                : TypographyColor.Darkgrey,
                    } as CenterTextProps
                }
            />
            <GridSlider length={repeater?.length || 0} bgColor={bgColor}>
                <Repeater
                    propName="repeater"
                    itemProps={{ bgColor: bgColor } as ImageTextSliderItemProps}
                />
            </GridSlider>
            <Spacer variant={!spacerBottom ? SpacerVariant.None : variantBottom} />
        </Background>
    )
}

ImageTextSlider.schema = {
    name: "ImageTextSlider",
    label: "Image Text Slider",
    previewImageUrl: `${process.env.IMG_CDN_URL_ASSETS}/lavita.de/startseite/screenshots_bricks/ImageTextSlider.png`,
    repeaterItems: [
        {
            name: "centerText",
            items: [
                {
                    type: "CenterText",
                    label: "Text",
                    max: 1,
                },
            ],
        },
        {
            name: "repeater",
            items: [
                {
                    type: "ImageTextSliderItem",
                    label: "Image Text Slider Item",
                    min: 1,
                },
            ],
        },
    ],
    sideEditProps: [
        {
            name: "background",
            label: "Background",
            type: types.SideEditPropType.Select,
            selectOptions: {
                options: backgroundOptions,
                display: types.OptionsDisplay.Color,
            },
        },
        {
            groupName: "Spacer",
            props: [
                {
                    name: "spacerTop",
                    label: "Spacer Top",
                    type: types.SideEditPropType.Boolean,
                },
                {
                    name: "variantTop",
                    label: "Spacer Variant",
                    type: types.SideEditPropType.Select,
                    selectOptions: {
                        options: spacerOptions,
                        display: types.OptionsDisplay.Select,
                    },
                    show: props => props.spacerTop === true,
                },
                {
                    name: "spacerBottom",
                    label: "Spacer Bottom",
                    type: types.SideEditPropType.Boolean,
                },
                {
                    name: "variantBottom",
                    label: "Spacer Variant",
                    type: types.SideEditPropType.Select,
                    selectOptions: {
                        options: spacerOptions,
                        display: types.OptionsDisplay.Select,
                    },
                    show: props => props.spacerBottom === true,
                },
            ],
        },
    ],
    getDefaultProps: (): ImageTextSliderProps => ({
        background: { color: BackgroundColor.White },
        spacerTop: true,
        spacerBottom: true,
        variantTop: SpacerVariant.Base,
        variantBottom: SpacerVariant.Base,
    }),
}

export default ImageTextSlider
